export default __webpack_public_path__ + "static/media/guidesMobile.98dfb6e5.PNG";